import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
}
function FAQItem({
  question,
  answer
}: FAQItemProps) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-gray-200 last:border-0" data-id="element-257">
      <button className="w-full py-4 px-2 flex justify-between items-center text-left focus:outline-none" onClick={() => setIsOpen(!isOpen)} data-id="element-258">
        <span className="font-bold text-gray-800 text-lg" data-id="element-259">{question}</span>
        {isOpen ? <ChevronUp className="w-5 h-5 text-gray-500" data-id="element-260" /> : <ChevronDown className="w-5 h-5 text-gray-500" data-id="element-261" />}
      </button>
      <div className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-96 opacity-100 pb-4' : 'max-h-0 opacity-0'}`} data-id="element-262">
        <p className="text-gray-600 px-2" data-id="element-263">{answer}</p>
      </div>
    </div>;
}
export function FAQ() {
  const faqs = [{
    question: '¿Sirve para cualquier Airfryer?',
    answer: 'Sí. El Tomo 1 te enseña a ajustar según tipo, tamaño y potencia.'
  }, {
    question: '¿Las recetas son complicadas?',
    answer: 'No. Son recetas prácticas, ingredientes comunes y pasos claros.'
  }, {
    question: '¿Puedo usarlo desde el celular?',
    answer: 'Sí. Está pensado para abrir, elegir y cocinar al momento.'
  }];
  return <div className="max-w-3xl mx-auto bg-white rounded-xl shadow-lg p-6 md:p-8" data-id="element-264">
      {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} data-id="element-265" />)}
    </div>;
}